import React from "react"
import { Link } from "gatsby"

const Header = ({ logo }) => {
  return (
    <header className="text-gray-700 body-font border-b border-gray-100">
      <div className="container mx-auto flex flex-wrap p-5 flex-col md:flex-row items-center">
        <Link
          to="/"
          className="flex title-font font-medium items-center text-gray-900 mb-4 md:mb-0"
        >
          <div style={{ width: "50px", height: "50px" }}>{logo}</div>
          <span className="ml-3 text-xl">gabriela muttoni</span>
        </Link>
        <nav className="md:ml-auto flex flex-wrap items-center text-base justify-center">
          <Link to="/reiki" className="mr-5 hover:text-purple-600">
            Reiki
          </Link>
          <Link to="/taro-alquimico" className="mr-5 hover:text-purple-600">
            Tarô
          </Link>
          <Link to="/florais" className="mr-5 hover:text-purple-600">
            Florais
          </Link>
          <Link to="/barras-de-access" className="mr-5 hover:text-purple-600">
            Barras
          </Link>
          <Link to="/glossario" className="mr-5 hover:text-purple-600">
            Glossário
          </Link>
        </nav>
        <a
          href="https://wa.me/5551993093330"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center bg-gray-200 border-0 py-1 px-3 focus:outline-none hover:bg-gray-300 rounded text-base mt-4 md:mt-0"
        >
          Contato
          <svg
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            className="w-4 h-4 ml-1"
            viewBox="0 0 24 24"
          >
            <path d="M5 12h14M12 5l7 7-7 7"></path>
          </svg>
        </a>
      </div>
    </header>
  )
}

export default Header
